<template>
  <div>
    <v-row>
      <v-col v-if="showFields.includes('salutation')" cols="12" md="4">
        <v-select
          v-model="form.salutation"
          name="salutation"
          :readonly="readonly"
          :items="salutations"
          :label="$t('PROFILE.SALUTATION')"
          :error-messages="errors.salutation"
          @change="updateValue('salutation', $event)"
        />
      </v-col>

      <v-col v-if="showFields.includes('firstName')" cols="12" md="4">
        <v-text-field
          v-model="form.first_name"
          name="first_name"
          :readonly="readonly"
          :counter="255"
          :rules="getRulesByName('first_name')"
          :label="`${$t('PROFILE.FIRST_NAME')} *`"
          :error-messages="errors.first_name"
          @input="updateValue('first_name', $event)"
        />
      </v-col>

      <v-col v-if="showFields.includes('lastName')" cols="12" md="4">
        <v-text-field
          v-model="form.last_name"
          name="last_name"
          :readonly="readonly"
          :counter="255"
          :rules="getRulesByName('last_name')"
          :label="`${$t('PROFILE.LAST_NAME')} *`"
          :error-messages="errors.last_name"
          @input="updateValue('last_name', $event)"
        />
      </v-col>

      <v-col v-if="showFields.includes('gender')" cols="12" md="4">
        <v-select
          v-model="form.gender"
          name="gender"
          :readonly="readonly"
          :items="genders"
          :label="$t('PROFILE.GENDER')"
          :error-messages="errors.gender"
          @change="updateValue('gender', $event)"
        />
      </v-col>

      <v-col v-if="showFields.includes('language_id')" cols="12" md="4">
        <v-select
          v-model="form.language_id"
          name="language_id"
          :readonly="readonly"
          :items="languages"
          item-value="id"
          item-text="name"
          :label="$t('PROFILE.LANGUAGE')"
          :error-messages="errors.language_id"
          @change="updateValue('language_id', $event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapCacheActions } from 'vuex-cache';
import formEditable from '@/modules/_global/mixins/form-editable';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { requiredTextLine } from '@/modules/_global/variables/rules.js';

export default {
  name: 'PersonForm',

  mixins: [formEditable, i18nRefreshData],

  props: {
    showFields: {
      type: Array,
      default() {
        return ['salutation', 'firstName', 'lastName', 'gender', 'language_id'];
      }
    }
  },

  data: () => ({
    form: {
      salutation: '',
      first_name: '',
      last_name: '',
      gender: '',
      language_id: 1
    },
    languages: [],
    rules: {
      firstName: requiredTextLine,
      lastName: requiredTextLine
    }
  }),

  computed: {
    salutations() {
      return [
        {
          text: this.$t('PROFILE.SALUTATIONS.MISTER[1]'),
          value: 'Mr.'
        },
        {
          text: this.$t('PROFILE.SALUTATIONS.MISSES[1]'),
          value: 'Mrs.'
        }
      ];
    },
    genders() {
      return [
        { text: this.$t('PROFILE.GENDERS.MALE'), value: 'Male' },
        {
          text: this.$t('PROFILE.GENDERS.FEMALE'),
          value: 'Female'
        }
      ];
    },
    maritalStatuses() {
      return [
        {
          text: this.$t('PROFILE.MARITAL_STATUSES.SINGLE'),
          value: 'Single'
        },
        {
          text: this.$t('PROFILE.MARITAL_STATUSES.MARRIED'),
          value: 'Married'
        },
        {
          text: this.$t('PROFILE.MARITAL_STATUSES.DIVORCED'),
          value: 'Divorced'
        },
        {
          text: this.$t('PROFILE.MARITAL_STATUSES.WIDOWED'),
          value: 'Widowed'
        }
      ];
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('localization', ['retrieveLanguages']),

    refreshData() {
      this.retrieveLanguages()
        .then(response => {
          this.languages = response.data;
        })
        .catch(({ response }) => {
          this.$emit('error-response', response);
        });
    }
  }
};
</script>
